import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const AdminFactors = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/admin/factors").then((r) => setF(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!f) return null;
  const set = (kind, t, v) => setF((x) => ({ ...x, [kind]: { ...x[kind], [t]: v } }));
  const save = async () => {
    try {
      const body = Object.fromEntries(["co2", "trees"].map((k) => [k, Object.fromEntries(Object.entries(f[k]).map(([t, v]) => [t, Number(v) || 0]))]));
      setF(await api.put("/admin/factors", body).then((r) => r.data));
      toast.success("Conversion factors saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-2xl space-y-4">
      <p className="text-sm text-[#4A6358]">These numbers turn kg recycled into the estimates customers see (CO2 avoided and trees saved). Customers see them labelled as estimates. Please check and adjust the starting values to the sources you trust.</p>
      <div className="overflow-hidden rounded-2xl border border-[#D2E0D8] bg-white">
        <table className="w-full text-sm" data-testid="admin-factors-table">
          <thead className="bg-[#EAEFEA] text-xs uppercase text-[#4A6358]"><tr><th className="px-4 py-3 text-left">Scrap type</th><th className="px-4 py-3 text-left">kg CO2 avoided per kg</th><th className="px-4 py-3 text-left">Trees saved per kg</th></tr></thead>
          <tbody>
            {Object.keys(f.co2).map((t) => (
              <tr key={t} className="border-t border-[#EAEFEA]">
                <td className="px-4 py-2 font-medium">{t}</td>
                {["co2", "trees"].map((k) => (
                  <td key={k} className="px-4 py-2"><Input type="number" step="0.001" min="0" value={f[k][t]} onChange={(e) => set(k, t, e.target.value)} className="h-9 w-32" data-testid={`factor-${k}-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button onClick={save} className="h-11 rounded-xl bg-[#0D3B2B] px-6 font-bold text-white" data-testid="admin-factors-save-btn">Save factors</button>
    </div>
  );
};
